class recentlyViewed {
  constructor(element) {
    console.log('constructing recents');
    if(!element){
      console.log('no recents element passed, false');
      return false;
    } else {
      element = element.get(0);
    }

    this.options = JSON.parse(element.getAttribute('data-section-settings'));

    this.element = element;

    if (this.options['productId']) {
      this._saveProduct(this.options['productId']);
    }

    this._fetchProducts();
  }

  _saveProduct(productId) {
    var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

    // We check if the current product already exists, and if it does not, we add it at the start
    if (!items.includes(productId)) {
      items.unshift(productId);
    }

    // Then, we save the current product into the local storage, by keeping only the 8 most recent
    try {
      localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
    } catch (error) {
      // Do nothing, this may happen in Safari in incognito mode
    }
  }

  _fetchProducts() {
    var _this63 = this;

    var queryString = this._getSearchQueryString();

    if (queryString === '') {
      return;
    }

    // If we have a non empty query string we do a search query
    var theFetch = window.routes.searchUrl + '?view=recently-viewed-products&type=product&q=' + queryString;
    console.log(theFetch);
    fetch(theFetch, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function (response) {
      response.text().then(function (results) {
        var limit = window.innerWidth <= 787 ? 3 : 4;

        var children = $(results).find('.results-box').children();
        if(children.length >= limit) {
          var html = $(results).find('.results-box').html();
          for(var i=0; i < 4; i++) {
            if(children[i]){
              $(_this63.element).find('.results-box').prepend(children[i]);
            }
          }
          // $(_this63.element).find('.results-box').html(html);
          $(_this63.element).parent('.shopify-section--hidden').removeClass('shopify-section--hidden');
        } else {
          console.log('not enough recents');
        }
      });
    });
  }

    _getSearchQueryString() {
      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

      // If we are on a product template, we make sure to remove the main product from the related product
      if (items.includes(this.options['productId'])) {
        items.splice(items.indexOf(this.options['productId']), 1);
      }

      return items.map(function (item) {
        return 'id:' + item;
      }).join(' OR ');
    }

}
export default recentlyViewed;
